<template>
  <div
    class="machines-table"
    style="height: 100%;">

    <el-divider v-if="!tableIsNotEmpty"/>
    <div
      v-if="!tableIsNotEmpty"
      class="boxes-table-no-data-container">
      <div class="boxes-table-no-data-container-body">
        <div class="boxes-table-no-data-image" />
        <div class="mt-24 el-text el-text--display-regular">
          {{ $t('wr-dashboard.machines-table.message.no-machines') }}
        </div>
      </div>
    </div>

    <el-table
      v-if="tableIsNotEmpty"
      style="height: 100%;"
      height="fit-scrollable"
      :data="getMachines"
      highlight-current-row
      :default-sort = "{ prop: 'displayName' }"
      :loading-append="isFetchMachinesInProgress"
      @row-click="onTableRowClick"
      ref="table"
      border-bottom>

      <el-table-column
        prop="id"
        label="id"
        hidden/>

      <el-table-column
        prop="machineId"
        label="machineId"
        hidden/>

      <el-table-column
        prop="displayName"
        :label="$t('wr-dashboard.machines-table.column.name')"
        align="left"
        sortable>
        <template slot-scope="{ row }">
          <el-icon name="svg-pc-clr--32"/>
          <span class="ml-16">
            {{ row.displayName }}
          </span>
        </template>
      </el-table-column>

      <el-table-column
        prop="size"
        width="190"
        :label="$t('wr-dashboard.machines-table.column.size')"
        :sort-by="row => row.size"
        sortable>
        <template slot-scope="{ row }">
          {{ row.size | size }}
        </template>
      </el-table-column>
      <template
        #append
      >
        <span v-if="!isFetchMachinesInProgress">
          <div class="machines-table-used-space el-text el-text--body-24">
            {{ $tc('wr-dashboard.machines-table.message.space-used:plural',
                   getTotalUsedSpace, {size: totalUsedSpaceText}) }}
          </div>
        </span>
      </template>

    </el-table>

  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import {
  PENDING_STATUS
} from '../store/action-status';

import {
  FETCH_CONTAINER_ITEMS, UPDATE_ACTIVE_MACHINE
} from '../store/action-types';

const { mapGetters, mapActions } = createNamespacedHelpers('wr-dashboard');

export default {
  name: 'MachinesTable',
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters([
      'getFetchContainerItemsStatus',
      'getMachines',
      'getTotalUsedSpace'
    ]),
    isFetchMachinesInProgress() {
      return this.getFetchContainerItemsStatus === PENDING_STATUS;
    },
    tableIsNotEmpty() {
      return this.isFetchMachinesInProgress || this.getMachines.length > 0;
    },
    totalUsedSpaceText() {
      return this.$options.filters.size(this.getTotalUsedSpace);
    }
  },
  methods: {
    ...mapActions({
      fetchMachines: FETCH_CONTAINER_ITEMS,
      updateActiveMachine: UPDATE_ACTIVE_MACHINE
    }),
    onTableRowClick(row, event, column) {
      this.updateActiveMachine({
        machineId: row.machineId,
        displayName: row.displayName
      });

      this.$emit('machineSelected');
    }
  },
  mounted() {
    this.fetchMachines();
  }
};
</script>

<style lang="scss" scoped>
  .boxes-table-no-data-container {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
  }

  .boxes-table-no-data-container-body {
    margin-left: 256px;
    margin-top: -78px;
  }

  .boxes-table-no-data-image {
    margin: auto;
    background: url('../assets/empty/empty-cloud.png') no-repeat;
    width: 128px;
    height: 128px;
  }

  .machines-table-used-space {
    text-align: center;
    margin-top: 20px;
  }
</style>
